export const MATCH_BREAKDOWN_DECIMALS = 2

export const MATCH_BREAKDOWN_COLUMNS = [
  { key: 'weight', labelKey: 'RentalPortal.MatchBreakdownColumnWeightKey' },
  { key: 'score', labelKey: 'RentalPortal.MatchBreakdownColumnScoreKey' },
  {
    key: 'contribution',
    labelKey: 'RentalPortal.MatchBreakdownColumnContributionKey',
  },
]
